import find from 'lodash/find';

export const YES_NO_TYPE = 1;
export const TEXT_INPUT_TYPE = 2;
export const WEEKS_TYPE = 3;

export const questionsProcessAndPolicies = [
  {
    kpiId : 'PRP-1',
    type : 'Strategy',
    category:'Processes & Policies',
    questions : [
      {
        text : 'Does the organization currently have a documented talent management strategy?',
        optionsType : YES_NO_TYPE,
        score : 3
      },
      {
        text : 'Does the organization currently have a documented process to implement the talent management strategy?',
        optionsType : YES_NO_TYPE,
        score : 3
      },
      {
        text : 'Does the organization currently have a documented strategy to support a respectful and fair workplace for all employees?',
        optionsType : YES_NO_TYPE,
        score : 3
      },
      {
        text : 'Does the organization have a documented process to carry out this strategy?',
        optionsType : YES_NO_TYPE,
        score : 3
      }
    ]
  },
  {
    kpiId : 'PRP-2',
    type : 'Infrastructure',
    category:'Processes & Policies',
    questions : [
      {
        text : 'Does the organization currently have assigned staff responsible for leading efforts that support a respectful and fair workplace for all employees?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text: 'Does the organization have a senior executive with a specific function of managing these efforts?',
        oldtext : 'Does the organization currently have a Chief Diversity Officer (CDO) or an equivalent executive with the primary function of managing DEI?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text:'Does this senior executive report directly to the CEO or President?',
        oldtext : 'Does the Chief Diversity Officer (CDO) or equivalent currently report to the CEO/President?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text : 'Does the organization currently have an allocated annual budget for efforts that support a respectful and fair workplace for all employees?',
        optionsType : YES_NO_TYPE,
        score : 2
      }
    ]
  },
  {
    kpiId : 'PRP-3',
    type : 'Accountability',
    category:'Processes & Policies',
    questions : [
      {
        text:'Does the organization currently task and measure progress of executives and managers towards creating a respectful and fair workplace?',
        oldtext : 'Does the organization currently task and measure progress of executives and managers towards DEI goals?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text:'Does progress towards meeting these goals currently influence performance evaluation for executives and managers?',
        oldtext : 'Does progress towards meeting DEI goals currently influence performance evaluation and compensation outcomes for executives and managers?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text:'Does the organization currently task and measure progress of supervisors/front-line managers towards creating a respectful and fair workplace?',
        oldtext : 'Does the organization currently task and measure progress of supervisors/front-line managers towards DEI goals?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text:'Does progress towards meeting these goals currently influence performance evaluation for supervisors/front-line managers?',
        oldtext : 'Does progress towards meeting DEI goals currently influence performance evaluation and compensation outcomes for supervisors/front-line managers?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text:'Does the organization currently have a clear, trusted process for raising concerns related to respect and fairness in the workplace?',
        oldtext : 'Does the organization currently task and measure progress of all employees towards DEI goals?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text:'Does the organization currently have a defined process to follow up and take action on concerns related to respect and fairness in the workplace?',
        oldtext : 'Does progress towards meeting DEI goals currently influence performance evaluation and compensation outcomes for all employees?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text:'In the most recent 12 months, has the organization conducted a compensation audit to ensure fairness, accuracy, and compliance of the compensation practices?',
        oldtext : 'In the most recent 12 months, has the organization conducted audits of gender-based variations in pay?',
        optionsType : YES_NO_TYPE,
        score : 2
      }
    ]
  },
  {
    kpiId : 'PRP-4',
    type : 'Training & Development',
    category:'Processes & Policies',
    questions : [
      {
        text:'In the most recent 12 months, has the organization conducted and/or sponsored leadership programs designed to address the unique needs of all employees from different backgrounds and communities?',
        oldtext : 'In the most recent 12 months, has the organization conducted and/or sponsored leadership programs specifically designed for diverse employees?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'In the most recent 12 months, has the organization had mentorship programs designed to address the unique needs of all employees from different backgrounds and communities?',
        oldtext : 'In the most recent 12 months, has the organization had a targeted mentorship program for diverse employees?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'In the most recent 12 months, has the organization developed career growth plans designed to address the unique needs of all employees from different backgrounds and communities?',
        oldtext : 'In the most recent 12 months, has the organization developed career growth plans for diverse employees?  ',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'In the most recent 12 months, has the organization conducted and/or sponsored training for executives and managers on building a respectful and fair workplace culture?',
        oldtext : 'In the most recent 12 months, has the organization conducted and/or sponsored DEI training for executives and managers?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'In the most recent 12 months, has the organization conducted and/or sponsored training for supervisors/front-line managers on building a respectful and fair workplace culture?',
        oldtext : 'In the most recent 12 months, has the organization conducted and/or sponsored DEI training for supervisors/front-line managers?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'In the most recent 12 months, has the organization trained decision makers at all levels to better understand the communities they serve and operate in, and the impact their decisions may have on these groups?',
        oldtext : 'In the most recent 12 months, has the organization trained managers on mitigating unconscious bias?',
        optionsType : YES_NO_TYPE,
        score : 1
      }
    ]
  },
  {
    kpiId : 'PRP-5',
    type : 'Parental Leave',
    category:'Processes & Policies',
    questions : [
      {
        text : 'What is the minimum fully paid maternity leave currently available to employees?',
        optionsType : WEEKS_TYPE
      },
      {
        text : 'What is the minimum fully paid paternity leave currently available to employees?',
        optionsType : WEEKS_TYPE
      },
      {
        text : 'For those employees that returned from maternity leave during the most recent 12 months, what was the average number of weeks taken?',
        optionsType : WEEKS_TYPE
      },
      {
        text : 'For those employees that returned from paternity leave during the most recent 12 months, what was the average number of weeks taken?',
        optionsType : WEEKS_TYPE
      }
    ]
  },
  {
    kpiId : 'PRP-6',
    type : 'Family/Elder Care',
    category:'Processes & Policies',
    questions : [
      {
        text : 'Does the organization currently provide backup family/elder care?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text : 'Does the organization currently provide a subsidy for family/elder care?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text : 'Does the organization currently provide on-site child care?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text : 'Does the organization currently provide referral services for family/elder care?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text : 'Does the organization currently provide other family/elder care?',
        optionsType : YES_NO_TYPE,
        score : 2
      }
    ]
  },
  {
    kpiId : 'PRP-7',
    type : 'Work Flexibility',
    category:'Processes & Policies',
    questions : [
      {
        text : 'Does the organization currently offer an option to control and/or vary the start/end times of the workday or workweek (e.g. flextime)?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text : 'Does the organization currently offer an option to control and/or vary the location where employees work from (e.g. telecommuting)?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text : 'Does the organization currently have a re-entry, on-boarding, or specific support program for employees returning from maternity, paternity, and/or other family leave?',
        optionsType : YES_NO_TYPE,
        score : 2
      }
    ]
  },
  {
    kpiId : 'PRP-8',
    type : 'Sexual Harassment',
    category:'Processes & Policies',
    questions : [
      {
        text : 'Does the organization  currently have a hotline where anyone can anonymously raise issues and submit complaints?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text : 'Does the organization currently have a sexual harassment policy?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text : 'Does the organization currently utilize an impartial third-party investigator to evaluate all sexual harassment allegations? ',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text : 'Does the organization currently prohibit inclusion of a confidentiality provision (or silencing agreement) in sexual harassment settlement agreements?',
        optionsType : YES_NO_TYPE,
        score : 1
      }
    ]
  },
  {
    kpiId : 'PRP-9',
    type : 'Leadership Alignment',
    category:'Processes & Policies',
    questions : [
      {
        text:'Is the organization’s current Board Chair or Lead Independent Director position held by someone with the full range of perspectives and experiences of the communities the organization serves and operates in?',
        oldtext : 'Is the organization’s current Board Chair or Lead Independent Director position held by a diverse Board member?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'Is the organization’s current CEO or equivalent position held by someone with the full range of perspectives and experiences of the communities the organization serves and operates in?',
        oldtext : 'Is the organization’s current CEO or equivalent position held by a diverse executive?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'Are there currently visible role models that reflect the full range of perspectives and experiences of the communities the organization serves and operates in at the C-suite and Executive levels?',
        oldtext : 'Are there currently visible diverse role models at the C-suite and Executive level?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'Are there currently visible role models that reflect the full range of perspectives and experiences of the communities the organization serves and operates in at the Managerial level?',
        oldtext : 'Are there  currently visible role models who are women and/or members of underrepresented groups at the Managerial level?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'Are there currently visible role models that reflect the full range of perspectives and experiences of the communities the organization serves and operates in at the Supervisory level?',
        oldtext : 'Are there currently visible role models who are women and/or members of underrepresented groups at the Supervisory level?',
        optionsType : YES_NO_TYPE,
        score : 1
      }
    ]
  },
  {
    kpiId : 'PRP-10',
    type : 'Fair Merit-based Recruiting',
    category:'Processes & Policies',
    questions : [
      {
        text:'Does the organization currently use a specific, defined recruiting strategy to ensure a fair merit-based process that removes barriers for candidates from the full range of communities it serves and operates in?',
        oldtext : 'Does the organization currently use a specific, defined recruiting strategy to increase diverse hires?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text:'Does the organization currently leverage sourcing channels designed to reduce barriers and improve access for candidates from the full range of communities it serves and operates in?',
        oldtext : 'Does the organization currently leverage DEI focused talent sources such as events, recruiting firms, job boards?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'Does the organization currently require that candidate slates for open roles reflect the full range of qualified talent from all communities it serves and operates in?',
        oldtext : 'Does the organization currently require a diverse slate of candidates for management and executive roles?',
        optionsType : YES_NO_TYPE,
        score : 2
      },
      {
        text:'Does the organization currently require that interview panels for management and executive roles reflect the full range of communities it serves and operates in?',
        oldtext : 'Does the organization currently require a diverse slate of interviewers for management and executive roles?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'Does the organization currently have a program for recruiting employees looking to transition back to the workforce after taking a career break?',
        oldtext : 'Does the organization currently have a program for recruiting diverse employees looking to transition back to the workforce after taking a career break?',
        optionsType : YES_NO_TYPE,
        score : 1
      }
    ]
  },
  {
    kpiId : 'PRP-11',
    type : 'Workplace Culture Advocacy',
    category:'Processes & Policies',
    questions : [
      {
        text :'In the most recent 12 months, has the organization communicated information about its respectful and fair workplace goals with employees?',
        oldtext : 'In the most recent 12 months, has the organization communicated information about its DEI goals with employees?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'In the most recent 12 months, has the organization communicated information about its respectful and fair workplace goals externally?',
        oldtext : 'In the most recent 12 months, has the organization communicated information about its DEI goals publicly?',
        optionsType : YES_NO_TYPE,
        score : 1
      },{
        text:'In the most recent 12 months, has the organization advocated more broadly (i.e., beyond itself) about respect and fairness in the workplace?',
        oldtext : 'In the most recent 12 months, has the organization been a signatory to, and/or has the CEO been a member of any organization(s) in which the primary mission is to advocate for gender equality?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'In the most recent 12 months, has the CEO personally advocated for a respectful and fair workplace internally?',
        oldtext : 'In the most recent 12 months, has the CEO personally advocated for DEI internally?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'In the most recent 12 months, has the CEO personally advocated for a respectful and fair workplace externally?',
        oldtext : 'In the most recent 12 months, has the CEO personally advocated for DEI externally?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'In the most recent 12 months, has the organization, CEO, Chairperson, or equivalent given monetary support to any non-profit organization(s) with a primary mission of advocating and promoting respect and fairness in the workplace?',
        oldtext : 'In the most recent 12 months, has the organization, CEO, Chairperson, or equivalent given monetary support to any non-profit organization(s) with a primary mission of advocating for gender equality in the workplace?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'In the most recent 12 months, has the organization applied for awards recognizing its efforts to create a respectful and fair workplace?',
        oldtext : 'In the most recent 12 months, has the organization applied for any DEI awards?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'In the most recent 12 months, has the organization won any awards recognizing its efforts to create a respectful and fair workplace?',
        oldtext : 'In the most recent 12 months, has the organization won any DEI awards?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text : 'In the most recent 12 months, has the organization conducted an employee engagement survey?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'In the employee engagement survey, conducted in the most recent 12 months, were specific questions around a respectful and fair workplace included?',
        oldtext : 'In the employee engagement survey, conducted in the most recent 12 months, were specific DEI questions included?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'For the employee engagement survey which included those questions conducted in the most recent 12 months, were action items generated and worked on?',
        oldtext : 'For the DEI survey, or employee engagement survey which included DEI questions, conducted in the most recent 12 months, were action items generated and worked on?',
        optionsType : YES_NO_TYPE,
        score : 1
      }
    ]
  },
  {
    kpiId : 'PRP-12',
    type : 'Resources & Support',
    category:'Processes & Policies',
    questions : [
      {
        text:'Does the organization currently have affinity networks or employee groups?',
        oldtext : 'Does the organization currently have diversity affinity networks or groups?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'Are the affinity networks or employee groups currently sponsored by an Executive?',
        oldtext : 'Are the diversity affinity networks or groups currently sponsored by an Executive?',
        optionsType : YES_NO_TYPE,
        score : 1
      },
      {
        text:'In the most recent 12 months, have executives regularly and actively participated in events or activities of the affinity networks or employee groups?',
        oldtext : 'In the most recent 12 months, have executives regularly and actively participate in events and activities of the diversity network or group?',
        optionsType : YES_NO_TYPE,
        score : 1
      }
    ]
  }
]

export const questionsBusinessCulture = [
  {
    type : 'EBIT Margin',
    kpiId : 'B&C-1',
    category:'Business & Culture',
    questions : [{
      text : 'What is the average EBIT margin in %, over the last (rolling) 12 months?',
      optionsType : TEXT_INPUT_TYPE
    }]
  },
  {
    type : 'Revenue Growth',
    kpiId : 'B&C-2',
    category:'Business & Culture',
    questions : [{
      text : 'What is the average monthly revenue growth rate in %, over the last (rolling) 12 months?',
      optionsType : TEXT_INPUT_TYPE
    }]
  },
  {
    type : 'ROIC',
    kpiId : 'B&C-3',
    category:'Business & Culture',
    questions : [{
      text : 'What is the average ROIC in %, over the last (rolling) 12 months?',
      optionsType : TEXT_INPUT_TYPE
    }]
  },
  {
    type : 'Mission Alignment',
    kpiId : 'B&C-4',
    category:'Business & Culture',
    questions : [{
      text : 'What % of employees would say they fully understand and support the organization\'s mission?',
      optionsType : TEXT_INPUT_TYPE
    }]
  },
  {
    type : 'Employee Engagement',
    kpiId : 'B&C-5',
    category:'Business & Culture',
    questions : [{
      text : 'What % of employees would say they feel they are fully contributing towards the organization\'s mission?',
      optionsType : TEXT_INPUT_TYPE
    }]
  },
  {
    type : 'Employee Dedication',
    kpiId : 'B&C-6',
    category:'Business & Culture',
    questions : [{
      text : 'What % of employees would say the organization motivates them to go beyond what they would in a similar role elsewhere?',
      optionsType : TEXT_INPUT_TYPE
    }]
  },
  {
    type : 'Employee Endorsement',
    kpiId : 'B&C-7',
    category:'Business & Culture',
    questions : [{
      text : 'What % of employees would  say they recommend their organization as a great place to work?',
      optionsType : TEXT_INPUT_TYPE
    }]
  },
  {
    type : 'Employee Loyalty',
    kpiId : 'B&C-8',
    category:'Business & Culture',
    questions : [{
      text : 'What % of employees would say they see themselves working at the organization in 2 years time?',
      optionsType : TEXT_INPUT_TYPE
    }]
  },
  {
    type : 'Employee Commitment',
    kpiId : 'B&C-9',
    category:'Business & Culture',
    questions : [{
      text : 'What % of employees would say they rarely look for a job elsewhere?',
      optionsType : TEXT_INPUT_TYPE	
    }]
  },
  {
    type : 'Employee Inclusivity & Belonging',
    kpiId : 'B&C-10',
    category:'Business & Culture',
    questions : [{
      text : 'What % of employees would say they feel they are included and belong in the organization?',
      optionsType : TEXT_INPUT_TYPE	
    }]
  }
]

export const questionsEmployeeLifecycle = [
  {
    type : 'Employee Growth',
    kpiId:'GRO-2',
    category : 'Employee Lifecycle',
    questions : [{
      text : 'What % of employees would say there are good career growth opportunities in the organization?',
      optionsType : TEXT_INPUT_TYPE
    }]
  },
  {
    type : 'Sponsorship (women / underrepresented)',
    kpiId:'GRO-6',
    category : 'Employee Lifecycle',
    questions : [
      {
        text : 'What % of executives and managers who are women and/or members of underrepresented groups have executive sponsors?',
        optionsType : TEXT_INPUT_TYPE
      }
    ]
  },
  {
    type : 'Sponsorship (all)',
    kpiId:'GRO-6a',
    category : 'Employee Lifecycle',
    questions : [
      {
        text : 'What % of all executives and managers have executive sponsors?',
        optionsType : TEXT_INPUT_TYPE
      }
    ]
  },
  {
    type : 'Mentorship',
    kpiId:'GRO-7',
    category : 'Employee Lifecycle',
    questions : [
      {
        text : 'What % of executives and managers have mentors?',
        oldtext : 'What % of diverse executives and managers have mentors?',
        optionsType : TEXT_INPUT_TYPE
      }
    ]
  },
  {
    type : 'Mentorship (all)',
    kpiId:'GRO-7a',
    category : 'Employee Lifecycle',
    questions : [
      {
        text : 'What % of all executives and managers have mentors?',
        optionsType : TEXT_INPUT_TYPE
      }
    ]
  },
  {
    type : 'Ready-now Executive Succession',
    kpiId:'GRO-8',
    category : 'Employee Lifecycle',
    questions : [
    {
      text : 'What % of ready-now succession candidates for executive roles are women and/or members of underrepresented groups?',
      optionsType : TEXT_INPUT_TYPE
    }]
  },
  {
    type : 'Future Executive Succession',
    kpiId:'GRO-9',
    category : 'Employee Lifecycle',
    questions : [{
      text : 'What % of future succession candidates who will be ready in 5 years or less for executive roles are women and/or members of underrepresented groups?',
      optionsType : TEXT_INPUT_TYPE
    }]
  },
  {
    type : 'Ready-now Management Succession',
    kpiId:'GRO-10',
    category : 'Employee Lifecycle',
    questions : [{
      text : 'What % of ready-now succession candidates for managerial roles are women and/or members of underrepresented groups?',
      optionsType : TEXT_INPUT_TYPE
    }]
  },
  {
    type : 'Future Management Succession',
    kpiId:'GRO-11',
    category : 'Employee Lifecycle',
    questions : [{
      text : 'What % of future succession candidates for managerial roles are female?',
      optionsType : TEXT_INPUT_TYPE
    }]
  },
  {
    type : 'Interviewers',
    kpiId:'HRT-3',
    category : 'Employee Lifecycle',
    questions : [{
      text : 'What % or interviewers over the last (rolling) 12 months, were women and/or members of underrepresented groups?',
      optionsType : TEXT_INPUT_TYPE
    }]
  },
  {
    type : 'Opt-Out (women / underrepresented)',
    kpiId:'HRT-8',
    category : 'Employee Lifecycle',
    questions : [
    {
      text : 'What % of separated employees over the last 12 (rolling) months, who were women and/or members of underrepresented groups, said they were opting out of the workforce?',
      optionsType : TEXT_INPUT_TYPE	
    }
  ]
  },
  {
    type : 'Opt-Out (all)',
    kpiId:'HRT-8a',
    category : 'Employee Lifecycle',
    questions : [
    {
      text : 'What % of all employees over the last 12 (rolling) months, said they were opting out of the workforce?',
      optionsType : TEXT_INPUT_TYPE	
    },
  ]
  }
]

export const questionsBoard = [
  {
    kpiId : 'REP-2',
    type : 'Board Makeup',
    category:'Board',
    questions : [
      {
        text : 'Currently what % of members of the Board of Directors are women and/or members of underrepresented groups?',
        optionsType : TEXT_INPUT_TYPE
      }
    ]
  }
]

export const getKpiNameByCode = (code) => {
  const allQuestions = questionsEmployeeLifecycle.concat(questionsBusinessCulture)
  .concat(questionsProcessAndPolicies).concat(questionsBoard);
  return find(allQuestions,(o) => o.kpiId === code).type;
}